import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/Home.vue'
import FormAdvanced from '@/components/FormAdvanced/FormAdvanced.vue'
import Result from '@/components/Result/Result.vue'
import Catalog from '@/components/Catalog/Catalog.vue'

Vue.use(Router)

export const ROUTE_HOME = 'home'
export const ROUTE_SEARCH = 'search'
export const ROUTE_RESULT = 'result'
export const CATALOG_DETAIL = 'catalog'

export default new Router({
  routes: [
    {
      path: '/',
      name: ROUTE_HOME,
      component: Home
    },
    {
      path: '/search',
      name: ROUTE_SEARCH,
      component: FormAdvanced
    },
    {
      path: '/result',
      name: ROUTE_RESULT,
      component: Result
    },
    {
      path: '/catalog/:id',
      name: CATALOG_DETAIL,
      component: Catalog
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js